<div class="px-[16px]">
  <div class="notion-divider my-[16px]"></div>
</div>
